module.exports = __webpack_public_path__ + "static/offer-pendrive-5f2247eab82cfe0a35b510870e049f4f.png";